import { reducers } from 'redux/core'
import request from 'sb-request'


const fetch = () => (
  request.post('graphql?name=vacancies', {
    body: {
      query: `{
        vacancies {
          id
          title
          description
          location
          department
          link
          status
          dateCreated
          lastUpdated
        }
      }`,
    },
    modifyResult: ({ vacancies }) => (vacancies || []),
  })
    .then((result) => {
      reducers.view.careersPage.setVacancies(result)
      return result
    })
)


export default {
  fetch,
}
